import { useEffect } from "react";

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content || "");
}

export default function SEO({ title, description, path = "/", image, type = "website", jsonLd }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) upsertMeta("name", "description", description);
    upsertMeta("property", "og:title", title || document.title);
    upsertMeta("property", "og:description", description || "");
    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:url", "https://merotires.com" + path);
    if (image) upsertMeta("property", "og:image", image);
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", title || "");
    upsertMeta("name", "twitter:description", description || "");

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", "https://merotires.com" + path);

    const existing = document.getElementById("mero-jsonld");
    if (existing) existing.remove();
    if (jsonLd) {
      const script = document.createElement("script");
      script.id = "mero-jsonld";
      script.type = "application/ld+json";
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
  }, [title, description, path, image, type, JSON.stringify(jsonLd)]);

  return null;
}

export function localBusinessJsonLd() {
  return {
    "@context": "https://schema.org",
    "@type": "AutoRepair",
    "name": "ميرو للإطارات وخدمات السيارات",
    "alternateName": "MERO TIRES & AUTO SERVICES",
    "telephone": "+966507359999",
    "url": "https://merotires.com",
    "areaServed": { "@type": "City", "name": "الرياض" },
    "serviceType": "خدمات إطارات متنقلة",
  };
}
